import { useLocation, useNavigate } from 'react-router-dom';

/** The Dashboard / Queue / AAS Solutions tab bar for the staff side. */
export function StaffTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tab = (path: string, label: string) => (
    <button
      className={`aas-tab${pathname === path ? ' on' : ''}`}
      onClick={() => navigate(path)}
      type="button"
    >
      {label}
    </button>
  );
  return (
    <div className="aas-tabs">
      {tab('/', 'Dashboard')}
      {tab('/queue', 'Queue')}
      {tab('/solutions', 'AAS Solutions')}
    </div>
  );
}
